/**
 * Created by Alican Köker on 2019-03-22.
 */

import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {EdisonSoundConfig} from "../../EdisonSoundConfig";

export class EdisonRespinIntroView extends ScreenView {

    private _introBackgroundTileLeft:PIXI.Sprite;
    private _introBackgroundTileRight:PIXI.Sprite;
    private _introBackgroundTileMask:PIXI.Graphics;
    private _orientation:Orientation;

    private _introAnimSpine:PIXI.spine.Spine;

    private _init:boolean = true;

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
    }

    protected initAnimations():void {
        this._introBackgroundTileLeft = new PIXI.Sprite(GameResources.getTextures("respinBgRight")[0]);
        this._introBackgroundTileRight = new PIXI.Sprite(GameResources.getTextures("respinBgLeft")[0]);

        this._introBackgroundTileLeft.anchor.set(.5);
        this._introBackgroundTileRight.anchor.set(.5);

        this._introBackgroundTileMask = new PIXI.Graphics();
        this._introBackgroundTileMask.beginFill(0xABCDEF, 1);
        this._introBackgroundTileMask.drawRect(0, 0, 752, 480);
        this._introBackgroundTileMask.endFill();

        this._introBackgroundTileLeft.mask = this._introBackgroundTileMask;
        this._introBackgroundTileRight.mask = this._introBackgroundTileMask;

        this._introAnimSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildParty"));
        this._introAnimSpine.visible = false;

        this.addChild(this._introBackgroundTileMask);
        this.addChild(this._introBackgroundTileLeft);
        this.addChild(this._introBackgroundTileRight);
        this.addChild(this._introAnimSpine);

        //super.show();
    }

    protected stopPresentation(closeCallback?:() => void):void {
        this._layer.removeChild(this);
        if(closeCallback) {
            closeCallback();
        }
        this._isShowing = false;
    }

    protected startPresentation(data?:ParsedServerData, onShowComplete?:() => void):void {
        this.playBGAnimations();
        super.startPresentation(data, onShowComplete);
    }


    public playBGAnimations():TimelineLite {
        const animDuration:number = .5;

        SlotGame.sound.fadeAmbience(0, 500);
        SlotGame.sound.playEffect(EdisonSoundConfig.instance.RESPIN_INTRO);
        SlotGame.sound.playAmbience(EdisonSoundConfig.instance.FREESPIN_AMBIANCE);

        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            TweenLite.to(this._introBackgroundTileLeft, animDuration, {x : 448, ease : Linear.easeNone});
            TweenLite.to(this._introBackgroundTileRight, animDuration, {x : 817, ease : Linear.easeNone});
        });


        tl.add(() => {
            this._introAnimSpine.visible = true;
            this._introAnimSpine.state.setAnimation(0, "WildRespin", false);
        }, animDuration);

        tl.add(() => {
            this.playRemoveBGAnimations();
        }, animDuration + 2.5);
        tl.add(() => {
            SlotGame.sound.fadeAmbience(1, 1000);
        }, animDuration + 4);

        return tl;
    }

    public playRemoveBGAnimations():TimelineLite {
        const animDuration:number = .6;

        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            TweenLite.to(this._introBackgroundTileLeft, animDuration, {x : 65, ease : Linear.easeNone});
            TweenLite.to(this._introBackgroundTileRight, animDuration, {x : 1210, ease : Linear.easeNone});
        });

        return tl;
    }

    protected onResize(resizeData:IResizeData):void {

        this._orientation = resizeData.orientation;

        this.setYPositions(resizeData.orientation);

        if(this._init) {
            this.setXPositions();
            this._init = false;
        }
    }

    private setXPositions():void {
        this._introBackgroundTileMask.position.x = 260;
        this._introAnimSpine.position.x = 510;
        this._introBackgroundTileLeft.position.x = 72;
        this._introBackgroundTileRight.position.x = 1210;
    }

    private setYPositions(orientation:Orientation):void {
        if(orientation === Orientation.LANDSCAPE) {
            this._introBackgroundTileMask.position.y = 90;
            this._introAnimSpine.position.y = 405;
            this._introBackgroundTileLeft.position.y = 330;
            this._introBackgroundTileRight.position.y = 330;
        } else {
            this._introBackgroundTileMask.position.y = -5;
            this._introAnimSpine.position.y = 302;
            this._introBackgroundTileLeft.position.y = 224;
            this._introBackgroundTileRight.position.y = 224;
        }
    }

}